import React from 'react';
import PageLayout from '../app/layout/PageLayout';
import PageMeta from '../utils/PageMeta';
import ContentMap from './ContentMap';

const AllTopicsView = () => (
  <PageLayout.Content noPaddingX noPaddingY>
    <PageMeta title="Content Map - Slab" />
    <ContentMap />
  </PageLayout.Content>
);

export default AllTopicsView;
